import { StudioPage } from '@hendrx/core/dashboard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/')({
  component: StudioIndexPage
});

function StudioIndexPage() {
  return <StudioPage />;
}
